import { cn } from '../../lib/utils'

function ScrollFade({
  isScrolled,
  children,
  className,
}: {
  isScrolled: boolean
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'sticky top-0 z-50 transition-all duration-50 pb-2',
        isScrolled
          ? 'bg-background/95 backdrop-blur-sm border-b border-border shadow-sm'
          : 'bg-transparent',
        className,
      )}
    >
      {children}
    </div>
  )
}

export { ScrollFade }
